import { Monitor, Tablet, Smartphone } from 'lucide-react';

export type DeviceType = 'desktop' | 'tablet' | 'mobile';

interface DeviceSwitcherProps {
  value: DeviceType;
  onChange: (device: DeviceType) => void;
}

const devices: { value: DeviceType; label: string; icon: typeof Monitor; width: string }[] = [
  { value: 'desktop', label: '桌面', icon: Monitor, width: 'w-full max-w-6xl' },
  { value: 'tablet', label: '平板', icon: Tablet, width: 'w-full max-w-3xl' },
  { value: 'mobile', label: '手機', icon: Smartphone, width: 'w-full max-w-sm' },
];

export function DeviceSwitcher({ value, onChange }: DeviceSwitcherProps) {
  return (
    <div className="flex items-center gap-1 p-1 rounded-lg bg-slate-100 dark:bg-slate-800">
      {devices.map((device) => {
        const Icon = device.icon;
        const active = value === device.value;
        return (
          <button
            key={device.value}
            type="button"
            onClick={() => onChange(device.value)}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
              active
                ? 'bg-white dark:bg-slate-700 text-blue-600 dark:text-blue-400 shadow-sm'
                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-600'
            }`}
          >
            <Icon size={16} />
            <span className="hidden sm:inline">{device.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export function getDeviceWidthClass(device: DeviceType): string {
  return devices.find((d) => d.value === device)?.width || 'w-full';
}
